export const normalizeImageUrl = (url?: string | null) => {
  if (!url) {
    return null
  }

  const collapseStaticPath = (pathname: string) => {
    return pathname
      .replace(/^\/static\/static\//, "/static/")
      .replace(/\/{2,}/g, "/")
  }

  if (url.startsWith("http://") || url.startsWith("https://")) {
    try {
      const parsed = new URL(url)
      parsed.pathname = collapseStaticPath(parsed.pathname)
      return parsed.toString()
    } catch {
      return url.replace("/static/static/", "/static/")
    }
  }

  return collapseStaticPath(url)
}

